import React, {useState} from 'react';
import {PlusOutlined,PlayCircleTwoTone, PaperClipOutlined} from '@ant-design/icons';
import {Button, Empty, Input, Modal, Typography, Upload} from 'antd';
import {withFormsy} from "formsy-react";

const {Text} = Typography
const {TextArea} = Input;
const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
const MAX_SIZE = 25 * 1024 * 1024 // 25MB in bytes
const MultiImageUpload = (props) => {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [preview, setPreview] = useState(null);

    // const fileList = useMemo(() => {
    //     return TB.map(props.getValue() || [], file => {
    //         let formatted = TB.clone(file);
    //         if (formatted.path) {
    //             formatted.url = formatted.path;
    //         }
    //         return formatted;
    //     })
    // }, [props.getValue() || []]);

    const checkFileType = (file) => {
        const isImageMime = file.type && file.type.startsWith('image/')
        const isVideoMime = file.type && file.type.startsWith('video/')
        const isImageExt = /\.(jpg|jpeg|png|gif|webp)$/i.test(file.path)
        const isVideoExt = /\.(mp4|webm|mov|avi|wmv)$/i.test(file.path)

        return {
            isImage: isImageMime || isImageExt || file.content_type ==='Image',
            isVideo: isVideoMime || isVideoExt || file.content_type ==='Video'
        }
    }
    const handleCancel = async () => {
        await setPreviewOpen(false);
        setPreview(null)
    };

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = file.path || await getBase64(file.originFileObj);
        }
        await setPreview(file);
        setPreviewOpen(true);
        // setPreviewTitle(file.caption || file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
    };
    const onChange = async ({file, fileList}) => {

        await TB.map(fileList, async (item, index) => {
            if (!item.caption && item.name?.length) {
                item.caption = TB.titleCase(item.name.replace(/\.[^/.]+$/, ""));
            }

            item.display_index = index + 1;
            if (!item.path && item?.response?.success?.data?.file_path) {
                item.path = item?.response?.success?.data?.file_path;

                // console.log('vidfeo', item.response.success.data.url, item.status === 'done' , fileType.isVideo , !item.url)
                // if (item.status === 'done' && fileType.isVideo && !item.url) {
                //     try {
                //
                //         console.log('vidfeo', item.response.success.data.url)
                //         const thumbnail = await getVideoThumbnail(item?.response?.success?.data?.url)
                //         item.url = URL.createObjectURL(thumbnail);
                //     } catch (err) {
                //         console.error('Error generating thumbnail:', err)
                //     }
                // }
            }
            if (!item.url && item?.response?.success?.data?.url) {
                let fileType = checkFileType(item)
                item.content_type = fileType.isImage ? 'Image' : 'Video';
                item.url = item?.response?.success?.data?.url;
            }
        })

        TB.map(fileList, (item, index) => {
            if (item.size > MAX_SIZE) {
                fileList.splice(index, 1);
            }
        })
        props.setValue(fileList)
    }

    const onRemove = (file) => {
        const index = (props.getValue() || []).indexOf(file);
        let updatedFileList = TB.clone(props.getValue() || [])
        const newFileList = updatedFileList.slice();
        newFileList.splice(index, 1);
        props.setValue(newFileList);
    }
    const getVideoThumbnail = (file) => {
        return new Promise((resolve, reject) => {
            const video = document.createElement('video')
            const canvas = document.createElement('canvas')
            const url = (file.originFileObj instanceof File) ? URL.createObjectURL(file) : file

            // Required attributes
            video.setAttribute('crossOrigin', 'anonymous')
            video.setAttribute('muted', '')
            video.setAttribute('playsinline', '')

            // Load metadata first
            video.addEventListener('loadedmetadata', () => {
                canvas.width = video.videoWidth
                canvas.height = video.videoHeight

                // Play and pause to ensure frame is loaded
                video.play().then(() => {
                    video.pause()

                    // Draw frame after a small delay to ensure it's ready
                    setTimeout(() => {
                        const ctx = canvas.getContext('2d')
                        try {
                            ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
                            canvas.toBlob((blob) => {
                                URL.revokeObjectURL(url)
                                resolve(blob)
                            }, 'image/jpeg')
                        } catch (err) {
                            URL.revokeObjectURL(url)
                            reject(err)
                        }
                    }, 100)
                }).catch(reject)
            })

            video.onerror = (e) => {
                URL.revokeObjectURL(url)
                reject(e)
            }

            video.src = url
        })
    }
    const errorMessage = (props.showError() || props.isFormSubmitted()) && props.getErrorMessage();

    let className = props.showRequired() ? 'required ' : '';

    className += (!props.isValid() && props.isFormSubmitted()) ? ' text-danger is-invalid ' : '';

    return (
        <div className={"multi-asset-upload transition-all ease-in flex flex-col form-group " + className + " " + props.className}>
            {props.label && (
                <label className={`col-form-label flex flex-row items-center ${props.labelClassName || ''}`}>
                    <span>{props.label}</span>
                    {props.required && <span className="required-symbol"> *</span>}
                    {props.getValue()?.length > 0 && (
                        <span className={TB.mapClass("ml-auto text-xxs italic", {
                            "opacity-7": props.getValue()?.length < props.maxCount,
                            "text-danger font-semibold opacity-1": props.getValue()?.length === props.maxCount,
                        })}>
                            Max ({props.getValue()?.length} / {props.maxCount})
                        </span>
                    )}
                </label>
            )}

            <Upload
                name={'file'}
                iconRender={(file, listType) => {
                    if (checkFileType(file)?.isVideo && file.status === 'done') {
                        return <PlayCircleTwoTone twoToneColor={TB.config('color.primary')} />
                    }else if (file.status === 'uploading') {
                        return 'Uploading...';
                    }else return <PaperClipOutlined/>
                }}
                onRemove={onRemove}
                onChange={onChange}
                action="/api/assets/upload"
                data={(file) => {
                    // Change request params
                    return {file: file}
                }}
                beforeUpload={(file, FileList) => {
                    if (file.size > MAX_SIZE) {
                        TB.toast(`Max upload size is 25MB`, {theme: 'danger'})
                        return false;
                    }
                }}
                accept={props.accept}
                multiple={true}
                maxCount={props.maxCount || 10}
                listType="picture-card"
                fileList={props.getValue() || []}
                onPreview={handlePreview}
            >
                {!props.disabled && (props.getValue() || []).length < (props.maxCount || 10) && (
                    <div>
                        <PlusOutlined/>
                        <div className="mt-2.5">
                            Add
                        </div>
                    </div>
                )}
            </Upload>

            {props.accept && (
                <Text type="secondary" className="text-xs italic mt-2">Accepted File Types: {TB.replace(props.accept, /,(?!\s)/g, ', ')}</Text>
            )}

            <div className="invalid-feedback block transition-all ease-in"
                 style={errorMessage ? {opacity: 1, height: 20, ...(props.invalidStyles || {})} : {
                     opacity: 0,
                     height: 0
                 }}>
                {errorMessage}
            </div>
            <Modal open={previewOpen} title={null} footer={null} onCancel={handleCancel}>
                {preview && (
                    <div className="flex flex-col gap-3">
                        <p className="font-medium">{`${props.display_label || 'Asset'} #${preview?.display_index}`}</p>
                        {checkFileType(preview)?.isImage ? <img
                            alt="example"
                            className="w-full"
                            src={preview?.path || preview?.url || preview?.preview}
                        /> : (
                            checkFileType(preview)?.isVideo ? (
                                <video className="w-full h-auto" controls={true} autoPlay muted src={preview.url || preview.path} />
                            ) : (
                                <Empty description="file type not supported"/>
                            )
                        )}
                        <div className="flex flex-col items-stretch gap-3">

                            <div>
                                <p className="text-xs font-semibold mb-2">
                                    Add a caption for this key visual
                                </p>
                                <TextArea
                                    rows={2} placeholder="Add a caption" maxLength={50} showCount
                                    value={preview?.caption} onChange={e => {
                                    props.setValue(TB.map(TB.cloneDeep(props.getValue()), (item, index) => {
                                        if (item.uid === preview?.uid) {
                                            item.caption = e.target.value;
                                        }
                                        return item;
                                    }))
                                }}/>
                            </div>

                            <div className="flex flex-row items-center gap-3 mt-2 justify-end">
                                <Button type="default" onClick={e => handleCancel()}>Cancel</Button>
                                <Button type="primary" onClick={e => handleCancel()}>Save</Button>
                            </div>
                        </div>

                    </div>
                )}
            </Modal>
        </div>
    )

};

export default withFormsy(MultiImageUpload)